import { EPaymentMethod } from 'app/react/types/payment';
import { ShiftStatusEnum } from 'app/react/types/station';
import { User } from 'app/react/types/user';
//
export interface IShift {
	organizationId: number;
	stationId: number;
	status: ShiftStatusEnum;

	openingUserId: number;
	openingCashAmount: number;
	openingDate: string;
	openingTime: string;

	closingUserId?: number;
	closingCashAmount?: number;
	closingDate?: string;
	closingTime?: string;

	reconcilingUserId?: number;
	reconciliationAmount?: number;
	reconcilingDate?: string;
	reconcilingTime?: string;
	reconciliationInvoiceId?: number;

	deletedAt?: Date;

	sumsOnShift?: Map<EPaymentMethod, number>;
	currentCashDifference?: number;

	openingUser?: User;
	closingUser?: User;
	reconcilingUser?: User;
}

export const SETTINGS_TABS = {
	ORGANIZATION: 'organization',
	FINANCIAL: 'financial',
	EMPLOYEES: 'employees',
	HISTORY: 'history',
} as const;

export type SettingsTab = (typeof SETTINGS_TABS)[keyof typeof SETTINGS_TABS];

export function isSettingsTab(value: string): value is SettingsTab {
	return (Object.values(SETTINGS_TABS) as readonly string[]).includes(value);
}

export interface RouteParams {
	id?: string;
	tab: string;
}